/* eslint-disable */
import React from "react";
import { getPropertyFolders } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";
import "./styles.scss";

const Folders = ({ getPropertyFolders, propertyFolders, period }) => (
  <DataTable
    {...tablePresets.folders}
    data={propertyFolders}
    fetchData={getPropertyFolders}
    period={period}
  />
);

const mapStateToProps = (state) => ({
  propertyFolders: state.appProperties.propertyFolders
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyFolders: (payload) => dispatch(getPropertyFolders(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Folders); 